// extracted by mini-css-extract-plugin
module.exports = {"root":"U8cqJ8fF","chipWrapper":"CWcrC6sc","dropdown":"Sk_BzAEq","dropdownItem":"vBSaxnEa","dropdownItemDisabled":"Ykyvj436","dropdownItemLabel":"Mod65nZk"};